import { Client } from './Client';
var TriageRegion = /** @class */ (function () {
    function TriageRegion() {
        this.ID = 0;
        this.GeoJson = "";
        this.CreatedDateTime = "";
        this.Name = "";
        this.IsActive = false;
        this.IsDeleted = false;
        this.ParentID = null;
        this.subTriageRegions = new Array();
        this.assignRegions = new Array();
        this.ParentRegionName = "";
        this.CheckedValue = "";
        this.Level = 0;
        this.StartDate = "";
        this.EndDate = "";
        this.ReleaseDate = "";
        this.AllowAfterEndDate = false;
        this.Client = new Client();
        this.toggle = "";
        this.Col = "collapsed";
    }
    return TriageRegion;
}());
export { TriageRegion };
var servicestatus = /** @class */ (function () {
    function servicestatus() {
        this.ID = 0;
        this.SubRegions = new Array();
    }
    return servicestatus;
}());
export { servicestatus };
//# sourceMappingURL=TriageRegion.js.map